import { reportClientError } from './appwrite/report-client-error';

interface ServiceWorkerContainerLike {
  register(scriptURL: string, options?: RegistrationOptions): Promise<unknown>;
}

/**
 * Activa la caché de red para audios de R2.
 *
 * La reproducción sigue funcionando si el navegador no admite workers o si
 * el registro falla; en ese caso simplemente vuelve a pedir cada archivo.
 */
export async function registerAudioCacheWorker(
  serviceWorker: ServiceWorkerContainerLike | undefined = navigator.serviceWorker,
): Promise<void> {
  if (!serviceWorker) return;
  try {
    await serviceWorker.register('/audio-cache-sw.js', { scope: '/' });
  } catch (caught) {
    console.error('[Rol Sensorial] No se pudo activar la caché de audio.', caught);
    reportClientError({
      source: 'web-app',
      operation: 'audio-cache-worker-register',
      level: 'warning',
      message: 'No se pudo activar la caché de audio.',
      details: String(caught),
    });
  }
}
